@if (!forceFallback() && displaySymbol(); as symbol) {
  @if (symbol.type === 'emoji') {
    <rt-emoji [emoji]="symbol.unicode" [size]="14" />
  } @else if (symbol.type === 'icon' && (!symbol.source || symbol.source === 'material')) {
    <rt-icon-font [name]="symbol.name" [size]="'small'" />
  } @else if (symbol.type === 'icon' && symbol.source === 'internal') {
    <rt-icon
      [name]="symbol.name"
      [style.color]="symbol.color ? `var(--${(kebabCase | fnCall: symbol.color)})` : null"
      size="small"
    />
  } @else if (symbol.type === 'svg') {
    <div [innerHTML]="trustHtml | fnCall: symbol.content"></div>
  }
} @else {
  @if (fallbackIcon(); as icon) {
    <rt-icon [name]="icon" size="small" />
  }
}
